module.exports = __webpack_public_path__ + "img/stats.fd75e36e.svg";